export default "__VITE_PUBLIC_ASSET__134f0b42__"